import { EnterpriseSelectorButton, IEnterpriseSelectorEnterprise } from '@cscglobal-tbs/enterprise-selector-ui';
import { PopoverProps } from '@fluentui/react-components';
import * as React from 'react';
import { useGetEnterprise, useGetEnterpriseList, usePutEnterprise } from '../../api/enterprise/enterprise';
import { useServiceDiscovery } from '../../hooks/useServiceDiscovery';
import { DATA_CONTEXT_OVERVIEW_HELPID } from '../../utils/Urls.constant';

export const EnterpriseSelectorContainer = () => {
    const { helpUrl } = useServiceDiscovery();
    const { data: enterpriseData, isError: enterpriseError, isLoading: enterpriseLoading } = useGetEnterprise();
    const { data: enterprisesListData, isError: enterpriseListError, isLoading: enterpriseListLoading } = useGetEnterpriseList();
    const { mutate: setEnterprise, isError: setEnterpriseError, isLoading: setEnterpriseLoading } = usePutEnterprise();

    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);

    const handleEnterpriseSelected = (enterpriseId: string) => {
        if (enterpriseId) {
            setEnterprise(
                { params: { enterpriseId } },
                {
                    onSuccess: () => {
                        setIsPopoverOpen(false);
                    },
                }
            );
        }
    };

    const handleOpenChange: PopoverProps['onOpenChange'] = (_e, data) => {
        setIsPopoverOpen(!!data.open);
    };

    return (
        <EnterpriseSelectorButton
            key={enterpriseData?.enterpriseName ?? 'empty'}
            isLoading={enterpriseLoading || enterpriseListLoading}
            selectedEnterpriseName={enterpriseData?.enterpriseName ?? ''}
            enterpriseList={(enterprisesListData as IEnterpriseSelectorEnterprise[]) ?? []}
            isPopoverOpen={isPopoverOpen}
            onHandleOpenChange={handleOpenChange}
            isUpdatingEnterprise={setEnterpriseLoading}
            isError={enterpriseError || setEnterpriseError || enterpriseListError}
            onEnterpriseSelected={handleEnterpriseSelected}
            helpUrl={`${helpUrl}&helpId=${DATA_CONTEXT_OVERVIEW_HELPID}`}
        />
    );
};
